module.exports = __webpack_public_path__ + "fonts/Inter-200-latin-ext16.fad2a54.woff2";